module.exports = __webpack_public_path__ + "f659bf7756acee0b32aa65fcab097163.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/plugin/images/google-2.png
// module id = 905
// module chunks = 3